<main class="grid min-h-screen place-items-center p-6">
  <p role="status">OK: frontend is healthy</p>
</main>
